var map = {
	"./step-1-ar.png": 1307,
	"./step-1-en.png": 1308,
	"./step-2-ar.png": 1309,
	"./step-2-en.png": 1310,
	"./step-3-ar.png": 1311,
	"./step-3-en.png": 1312,
	"./step-4.png": 1313,
	"./step-5-ar.png": 1314,
	"./step-5-en.png": 1315
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1306;